<template>
  <v-app style="margin-top: 0;">
    <v-sheet
        min-height="72px"
        color="#ccd6e2"
        elevation="2"
        style="border-bottom:1px solid rgba(0,0,0,0.15);"
    >
      <v-row no-gutters align="center" style="height:72px;">

        <v-col
            cols="12"
            xl="2"
            lg="2"
            md="2"
            xxl="2"
            class="d-flex align-center"
            style="height:100%;"
        >
          <img
              src="../src/assets/logo.png"
              alt="Logo"
              class="logo mt-3"
              style="height: 70px"
              @click="goHomeIfNotHome"
          />
        </v-col>
        <v-col
            cols="12"
            xl="10"
            lg="10"
            md="10"
            xxl="10"
            class="d-flex align-center"
        >
          <v-tabs
              v-model="tabIndex"
              align-tabs="start"
              show-arrows
              background-color="#ccd6e2"
              class="tabs-no-bg"
          >
            <v-tab class="tab_style">
              <v-icon>mdi-home</v-icon>&nbsp;Home
            </v-tab>

            <v-tab class="tab_style">
              <v-menu offset-y open-on-hover close-delay="400">
                <template v-slot:activator="{ on, attrs }">
                  <div
                      v-bind="attrs"
                      v-on="on"
                      id="searchTabID"
                      class="tab_style tab_dropdown"
                  >
                    <v-icon>mdi-magnify</v-icon>&nbsp;Search
                    <v-icon small>mdi-menu-down</v-icon>
                  </div>
                </template>

                <v-list>
                  <v-list-item to="/single-search">
                    <v-list-item-title>Single Search</v-list-item-title>
                  </v-list-item>
                  <v-list-item to="/batch-search">
                    <v-list-item-title>Batch Search</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-tab>

            <v-tab class="tab_style">
              <v-icon>mdi-book-open-outline</v-icon>&nbsp;SignatureDB
            </v-tab>


            <v-tab class="tab_style">
              <v-icon>mdi-chart-bar"></v-icon>&nbsp;Statistics
            </v-tab>

            <v-tab @click="opendoc" class="tab_style">
              <v-icon>mdi-help-circle-outline"></v-icon>&nbsp;Documentation
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
    </v-sheet>

    <v-main class="transparent">
      <keep-alive>
        <router-view />
      </keep-alive>
      <report-problem-button />
    </v-main>


    <footer class="mt-2 mr-2 text-right footer_style">
      © {{curr_year}} <a href="https://www.zhang-lab.org/">Zhang Lab</a>
    </footer>
  </v-app>

</template>

<script>
import reportProblemButton from "@/components/ReportProblemButton.vue";
export default {
  name: 'App',
  components: {
    reportProblemButton,
  },
  data(){
    return {
      curr_year: "",
    }
  },
  computed: {
    tabIndex: {
      get () {
        const p = this.$route.path || '/'
        if (p.startsWith('/single-search') || p.startsWith('/batch-search')) return 1
        if (p.startsWith('/signaturedb')) return 2
        if (p.startsWith('/signature')) return 2
        // if (p.startsWith('/downloads')) return 3
        if (p.startsWith('/statistics')) return 3
        if (p.startsWith('/doc')) return 4

        return 0
      },
      set (val) {
        switch (val) {
          case 0: this.$router.push('/'); break
          case 1: this.$router.push('/single-search'); break
          case 2: this.$router.push('/signaturedb'); break
          // case 3: this.$router.push('/downloads'); break
          case 3: this.$router.push('/statistics'); break
          case 4: this.$router.push('/doc'); break

        }
      }
    }
  },
  methods: {
    goHomeIfNotHome () {
      if (this.$route.path !== '/home' && this.$route.path !== '/') {
        this.$router.push('/')
      }
    },
    opendoc(){
      window.open("/docs/", "_blank");
      // http://www.ptmax.org/ptmatlas/docs/
    }
  },
  beforeMount() {
    this.curr_year = new Date().getFullYear();
  }
}
</script>

<style scoped>

.tabs-no-bg {
  background: transparent !important;
}

.tab_style {
  font-weight: 600 !important;
  font-size: 15px !important;
  color: #1a2733 !important;
  text-transform: none !important;
  padding: 0 20px !important;
}

.tab_style:hover {
  background-color: rgba(0, 0, 0, 0.07) !important;
}

.v-tab--active {
  color: #0066cc !important;
  border-bottom: 3px solid #0066cc !important;
}

.tab_dropdown {
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 100%;
}

.footer_style {
  color: #555;
}
.footer_style a {
  color: #0066cc;
}


</style>
